import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TELEGRAM_CHANNEL_URL } from '../../config/social';

const OrganizationSchema = () => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Jobs Opportunity',
    alternateName: 'JobsOpportunity.in',
    url: 'https://jobsopportunity.in',
    logo: {
      '@type': 'ImageObject',
      url: 'https://jobsopportunity.in/images/logo-dark.png',
      width: 512,
      height: 512
    },
    description: 'Discover the latest job opportunities across various industries. Find your dream job with Jobs Opportunity - your trusted job search platform.',
    foundingDate: '2024',
    sameAs: [
      'https://www.facebook.com/people/Jobs-Opportuniti/pfbid0vDPT2QsHfzUS26Q94JgptsuioacViMEiDH3JKFBVgiv27SxnjSsthk7r63EZNXw9l/',
      'https://www.instagram.com/jobsopportunity.in/',
      'https://x.com/Jobsopport61352',
      TELEGRAM_CHANNEL_URL
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-9380867233',
      contactType: 'customer service',
      availableLanguage: 'English'
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'IN',
      addressRegion: 'India'
    },
    areaServed: {
      '@type': 'Country',
      name: 'India'
    },
    serviceType: 'Job Search Platform',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Job Listings',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Job Search',
            description: 'Find and apply for jobs across various industries'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Career Blog',
            description: 'Career advice and industry insights'
          }
        }
      ]
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default OrganizationSchema; 